module.exports = __webpack_public_path__ + "static/Muli-Light-669dcbe48a12177c12a3c0e6354c1590.ttf";